import * as Quill from "quill";
import Delta from "quill-delta";

import { HttpClient } from "@angular/common/http";
import {
    AfterViewInit,
    Component,
    ElementRef,
    HostListener,
    Input,
    OnDestroy,
    OnInit,
    ViewChild,
} from "@angular/core";
import {
    FormBuilder,
    FormControl,
    FormGroup,
    Validators,
} from "@angular/forms";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { DomSanitizer } from "@angular/platform-browser";
import { FuseConfirmDialogComponent } from "@fuse/components/confirm-dialog/confirm-dialog.component";
import { FuseProgressBarService } from "@fuse/components/progress-bar/progress-bar.service";
import { Environment } from "app/decorators/environment.decorator";
import { TenantService } from "app/tenant/tenant.service";
import { RequireMatch } from "app/validators/requireMatch";
import moment from "moment";
import { QuillEditorComponent } from "ngx-quill";
import {
    debounceTime,
    distinctUntilChanged,
    Subject,
    Subscription,
    takeUntil,
} from "rxjs";
import { OrderDiagnosis } from "../../../../../../../../shared/cw-backend/models/attendance/order-diagnosis";
import {
    Document,
    DocumentModel,
} from "../../../../../../../../shared/cw-backend/models/operational/tools/document-model/document-form";
import { ParameterProvider } from "../../../../../../../../shared/cw-backend/providers/application/parameter/parameter.provider";
import { AttendanceListProvider } from "../../../../../../../../shared/cw-backend/providers/attendance/attendance/attendance-list.provider";
import { MedicalProvider } from "../../../../../../../../shared/cw-backend/providers/operational/medical/medical.provider";
import { DocumentModelListProvider } from "../../../../../../../../shared/cw-backend/providers/operational/tools/document-model/document-model-list.provider";
import { ExpressionProvider } from "../../../../../../../../shared/cw-backend/providers/operational/tools/expression/expression.provider";
import { PatientEditProvider } from "../../../../../../../../shared/cw-backend/providers/register/operational/patient/patient-edit.provider";
import {
    CwUtils,
    PageOptions,
} from "../../../../../../../../shared/cw-utils/cw-utils.service";
import { SnackBarService } from "../../../../../../../../shared/cw-utils/snackbar.service";
import { ConfigOnly } from "../../../tools/document-model/document-editor/config";
import { OnllyofficeService } from "../../../tools/document-model/document-editor/document-editor.service";
import { CalculateFormulasComponent } from "../calculate-formulas/calculate-formulas.component";
import { PatientAttachmentComponent } from "../patient-attachment/patient-attachment.component";
import { PatientCaptureComponent } from "../patient-capture/patient-capture.component";
import { PrintGcpComponent } from "../print-gcp/print-gcp.component";
import { SignatureDocumentComponent } from "../signature-document/signature-document.component";

@Component({
    selector: "app-patient-evolution",
    templateUrl: "./patient-evolution.component.html",
    styleUrls: ["./patient-evolution.component.scss"],
})
export class PatientEvolutionComponent
    implements OnInit, AfterViewInit, OnDestroy
{
    // Variáveis públicas
    public innerWidth: any;
    public result: string;
    public tabs = ["Novo"];
    public selected = new FormControl(0);
    public pdfSrc: string = null;
    public pdfHistorySrcFHD: string = null;
    public pdfHistorySrcHD: string = null;
    public sizeScreen: string = null;
    public zoom: any = "page-width";
    quillInstance!: Quill;
    public configEditor = {
        toolbar: [
            ["bold", "italic", "underline", "strike"],
            [{ header: 1 }, { header: 2 }],
            [{ font: [] }],
            [{ color: [] }, { background: [] }],
            [{ align: [] }],
        ],
    };

    // Variáveis privadas
    private _unsubscribeAll: Subject<any>;

    // Variáveis de controle de formulário
    public modelsControl: FormControl;
    public documentForm: FormControl;
    public specialityControl = new FormControl(null, [
        Validators.required,
        RequireMatch.bind(this),
    ]);

    // Variáveis de estado e opções
    public isButtonDisabled = false;
    public signingDocument = false;
    public loading: boolean = false;
    public signatureValidation: any = null;
    public signatureValidationLoading: boolean = false;
    public toggleHistory: boolean = false;
    public pdfHistory: boolean = false;
    public showPatientInfoMobile: boolean = false;
    public quillFullscreen: boolean = false;
    public onlyOfficeFullscreen: boolean = false;
    public onlyOfficeFullscreenMode: "tab" | "screen" | null = null;
    public selectedIndex: number = 0;
    public totalElements = 0;
    public pagina = 0;
    public tamanho = 0;
    public sizeClassHistory = 95;

    // Variáveis de dados e modelos
    public date = new Date();
    public nameDocument: string;
    public typeDocument: number;
    public imagePath: any;
    public document = new Document();
    public documentModel: any;
    public modelsList: DocumentModel[];
    public specialityList = new Array<any>();

    // Opções de página
    public modelsPageOptions: PageOptions;
    public pageOptions: PageOptions;
    public specialityPageOptions: PageOptions;
    sliderValue: number = 30;
    // ViewChild e injeção de dependências
    @ViewChild("quill", { static: false }) editor: ElementRef;
    @ViewChild("quill", { static: false }) quillEditor: QuillEditorComponent;
    @ViewChild("onlyOfficeShell", { static: false })
    onlyOfficeShell: ElementRef<HTMLElement>;
    @Environment("urlOnlyoffice") baseUrl: string;
    public http: HttpClient;
    editorOnly: any;
    public configonly: ConfigOnly;

    // Grupos de formulários
    public range: FormGroup;

    //Cid
    cidListSelected = new Array();
    CIDList: any[] = [];
    cidFormControl = new FormControl();
    cidPageOptions: PageOptions;
    processType: boolean = false;
    @ViewChild("cidInput") cidInput: ElementRef<HTMLInputElement>;
    @Input() data: any;
    isButtonDisabledByDocument = false;
    private loadingSavedDocument = false;
    private isDestroyed = false;
    private closingDocument = false;
    private documentSavedOnClose = false;
    private pendingOnlyOfficeSave: Promise<void> = null;
    private pendingOnlyOfficeSaveKey: string = null;
    private subscription: Subscription;

    selectedDocuments: any[] = [];

    constructor(
        public documentModelListProvider: DocumentModelListProvider,
        private expressionProvider: ExpressionProvider,
        public dialogRef: MatDialogRef<PatientEvolutionComponent>,
        private patientEditProvider: PatientEditProvider,
        private progressBar: FuseProgressBarService,
        private snackBar: SnackBarService,
        public dialog: MatDialog,
        private attendanceListProvider: AttendanceListProvider,
        private medicalProvider: MedicalProvider,
        private parameterProvider: ParameterProvider,
        private elementRef: ElementRef,
        private _sanitizer: DomSanitizer,
        private _formBuilder: FormBuilder,
        public tenantService: TenantService,
        private only: OnllyofficeService,
    ) {
        this._unsubscribeAll = new Subject();
        this.modelsControl = new FormControl();
        this.documentForm = new FormControl(
            this.document?.document ? this.document.document : null,
        );
        this.modelsPageOptions = new PageOptions();
        this.cidPageOptions = new PageOptions();
        this.pageOptions = new PageOptions();
        this.specialityPageOptions = new PageOptions();
        this.configonly = new ConfigOnly();
        this.specialityPageOptions.fieldSort = "speciality.name";
    }

    ngOnDestroy(): void {
        this.isDestroyed = true;
        this.setQuillFullscreen(false);
        this.setOnlyOfficeFullscreen(false);
        this.subscription.unsubscribe();
        if (this.document.id == null && this.documentForm.value != null) {
            if (this.isButtonDisabled) {
                return;
            }
            this.isButtonDisabled = true;

            setTimeout(() => {
                this.isButtonDisabled = false;
            }, 3000);
            this.insertAutomatic("html", null);
        }

        if (
            this.document.id != null &&
            (this.document.format === "docx" || this.document.format === "rtf")
        ) {
            if (this.documentSavedOnClose) {
                this.only.onDestroyEditor();
            } else {
                const editor = this.only.Editor;
                void this.persistOnlyOfficeDocument(this.document)
                    .catch((error) => console.error("Erro ao salvar documento ao sair:", error))
                    .finally(() => {
                        if (this.only.Editor === editor) {
                            this.only.onDestroyEditor();
                        }
                    });
            }
        }
    }

    ngOnInit() {
        this.subscription = this.only.documentState$.subscribe((state) => {
            this.isButtonDisabled = state; // true = desabilitado, false = habilitado
        });

        OnllyofficeService.editorInstance.subscribe({
            next: (e: any) => {
                this.editorOnly = e;
            },
        });
        this.range = this.createDateForm();
        this.parameterProvider
            .getValueByParameterOrParameterValueParameter(
                "VIEW_HISTORY_MEDICAL_MODULE",
                this.data.performer.id,
            )
            .then((res) => {
                if (res.body == "1") {
                    this.toggleHistory = window.innerWidth >= 960;
                } else if (res.body == "0") {
                    this.toggleHistory = false;
                }
            });

        this.historyDocument();
        this.typeDocument = this.data.type;

        if (this.data.documentId != null && this.data.context == "document") {
            this.getDocumentById(this.data.documentId);
            this.modelsControl.disable();
        } else {
            this.resumeTodayDocument();
        }

        this.getMainImage();
        this.nameDocument = this.data.nameDocument;
        this.getModelsType(this.data.type);
        this.observableModels();
        this.getDocuments();
        this.getSpeciality();
        this.ObservableFormat();
        this.innerWidth = window.innerWidth;
        this.observableDate();
        this.getCids();
        this.filterCid();
    }

    private resumeTodayDocument(): void {
        const patientId = this.data?.patient?.id;
        const performerId = this.data?.performer?.id;

        if (!patientId || !performerId || this.typeDocument == null) {
            return;
        }

        this.medicalProvider
            .getResumableDocumentId(patientId, this.typeDocument, performerId)
            .then((response) => {
                const documentId = response?.body;

                if (this.isDestroyed || !documentId || this.document?.id) {
                    return;
                }

                this.modelsControl.disable();
                this.getDocumentById(documentId);
            })
            .catch(() => {
                // A retomada é opcional; uma falha não deve bloquear um novo lançamento.
            });
    }

    ngAfterViewInit() {
        //this.colorDefault();
        var inputElement = document.querySelector("#quill .ql-editor");

        if (inputElement) {
            (inputElement as HTMLInputElement).focus();
        }
    }

    displayFn(event?: any): string | undefined {
        if (!event) {
            return null;
        }
        return event.title;
    }

    createDateForm(): FormGroup {
        return this._formBuilder.group({
            start: new FormControl(),
            end: new FormControl(),
        });
    }

    getModelsType(type?: number) {
        this.modelsPageOptions.fieldSort = "title";

        this.documentModelListProvider
            .getPageTypeAndPerformerId(
                this.modelsPageOptions,
                type,
                this.data.performer.id,
            )
            .then((res) => {
                this.modelsList = res.body.content;
            });
    }

    getHeight(): number {
        const width = window.innerWidth;
        if (width < 1300) {
            return 200;
        } else if (width < 1367) {
            return 300; // Defina a altura para telas menores que 768px
        } else {
            return 500; // Defina a altura para telas maiores que 992px
        }
    }

    openPanel(document, indice) {
        this.selectedIndex = indice;
        if (document.format == "docx" || document.format == "rtf") {
            this.medicalProvider.generatePdf(document).then((x) => {
                this.pdfSrc = null;
                this.zoom = "page-width";
                this.pdfSrc = x.pdf;
                var newBlob = new Blob([x], { type: "application/pdf" });
                const nav = window.navigator as any;
                if (nav && nav.msSaveOrOpenBlob) {
                    nav.msSaveOrOpenBlob(newBlob);
                    return;
                }
                const data = window.URL.createObjectURL(newBlob);
            });
        } else if (document.format == "html" || document.format == "text") {
            this.medicalProvider.getDocumentById(document.id).then((res) => {
                this.result = decodeURIComponent(
                    escape(window.atob(res.body.document)),
                );
            });
        }
    }

    stopPropagation(event: Event) {
        event.stopPropagation();
    }

    signDocument(event: Event, document: any, download?) {
        this.stopPropagation(event);

        if (this.signingDocument || this.isButtonDisabled) {
            return;
        }

        this.signingDocument = true;

        this.progressBar.show();

        const isOnlyOffice = document.format === "docx" || document.format === "rtf";
        const save = isOnlyOffice
            ? this.persistOnlyOfficeDocument(document)
            : this.medicalProvider.onRequestSaveAs(this.configonly.key);

        save
            .then(() => {
                if (this.isDestroyed) {
                    return;
                }

                const dialogRef = this.dialog.open(SignatureDocumentComponent, {
                    disableClose: false,
                    width: "520px",
                    maxWidth: "95vw",
                    data: {
                        document,
                        performer: this.data.performer,
                        type: "D",
                    },
                });

                dialogRef.afterClosed().subscribe(() => {
                    if (!this.isDestroyed) {
                        this.getDocumentById(document.id);
                    }
                });
            })
            .catch((error) => {
                this.snackBar.warnMessage(
                    error?.error?.message ||
                        error?.message ||
                        "O documento não foi salvo. A assinatura não foi iniciada; tente novamente.",
                );
            })
            .finally(() => {
                this.signingDocument = false;
                this.progressBar.hide();
            });
    }

    signDocumentToList(event: Event, document: any, download?) {
        this.stopPropagation(event);

        if (document.id === this.document?.id && this.only.Editor && this.configonly?.key) {
            this.signDocument(event, document);
            return;
        }

        const dialogRef = this.dialog.open(SignatureDocumentComponent, {
            disableClose: false,
            width: "520px",
            maxWidth: "95vw",
            data: {
                document: document,
                performer: this.data.performer,
                type: "D",
            }, // se precisar
        });

        dialogRef.afterClosed().subscribe((selectedClearance) => {
            if (!selectedClearance) return;
            this.isButtonDisabled = false;
        });
    }

    resignDocument(event: Event, document: any) {
        this.stopPropagation(event);

        const dialogRef = this.dialog.open(SignatureDocumentComponent, {
            disableClose: false,
            width: "520px",
            maxWidth: "95vw",
            data: {
                document: document,
                performer: this.data.performer,
                type: "D",
            },
        });

        dialogRef.afterClosed().subscribe((selectedClearance) => {
            this.getDocumentById(document.id);
            if (!selectedClearance) return;
            this.isButtonDisabled = false;
        });
    }

    closedPanel(document) {
        this.pdfSrc = null;
    }

    async saveBeforeLeaving(): Promise<boolean> {
        if (this.closingDocument) {
            return false;
        }

        if (this.document.id == null || !this.isOnlyOfficeDocument(this.document)) {
            return true;
        }

        this.closingDocument = true;
        this.progressBar.show();
        try {
            await this.persistOnlyOfficeDocument(this.document);
            this.documentSavedOnClose = true;
            return true;
        } catch (error) {
            console.error("Erro ao salvar documento antes de sair:", error);
            this.snackBar.warnMessage("O documento não foi salvo. Tente novamente antes de sair.");
            return false;
        } finally {
            this.progressBar.hide();
            this.closingDocument = false;
        }
    }

    async closeModal() {
        if (!(await this.saveBeforeLeaving())) {
            return;
        }

        if (this.document.id == null && this.documentForm.value != null) {
            if (this.isButtonDisabled) {
                return;
            }
            this.isButtonDisabled = true;

            setTimeout(() => {
                this.isButtonDisabled = false;
            }, 3000);

            this.insertAutomatic("html", null);
        }
        this.dialogRef.close();
    }

    historyDocument() {
        this.parameterProvider
            .getValueByParameterOrParameterValueParameter(
                "DOCUMENT_HISTORY_PATIENT",
                this.data.performer.professional.id,
            )
            .then((res) => {
                console.log("🚀 ~ .then ~ res:", res);
                if (res.body == "1") {
                    const width = window.innerWidth;

                    if (width >= 1920) {
                        this.printHistory(this.data.patient.id);
                    } else if (width >= 1280 && width <= 1920) {
                        this.printHistoryHD(this.data.patient.id);
                    } else {
                        console.log("Outra resolução");
                        // outro comportamento
                    }
                }
            });
    }

    private isOnlyOfficeDocument(document: Document): boolean {
        return document?.format === "docx" || document?.format === "rtf";
    }

    private waitForOnlyOfficeSync(editor: any, key: string): Promise<void> {
        if (!this.only.documentStateSubject.value) {
            return Promise.resolve();
        }

        return new Promise((resolve, reject) => {
            let subscription: Subscription;
            const timeout = setTimeout(() => {
                subscription?.unsubscribe();
                reject(new Error("As alterações ainda não chegaram ao servidor OnlyOffice."));
            }, 15000);
            subscription = this.only.documentState$.subscribe((editing) => {
                if (!editing) {
                    clearTimeout(timeout);
                    subscription.unsubscribe();
                    if (this.only.Editor !== editor || this.configonly.key !== key) {
                        reject(new Error("O editor foi alterado durante o salvamento."));
                    } else {
                        resolve();
                    }
                }
            });
        });
    }

    private persistOnlyOfficeDocument(document: Document): Promise<void> {
        if (!this.isOnlyOfficeDocument(document) || document.id !== this.document.id) {
            return Promise.resolve();
        }

        if (!this.only.Editor || !this.configonly.key) {
            return Promise.reject(new Error("O editor do documento ainda não está pronto."));
        }

        if (this.pendingOnlyOfficeSave && this.pendingOnlyOfficeSaveKey === this.configonly.key) {
            return this.pendingOnlyOfficeSave;
        }

        const key = this.configonly.key;
        const editor = this.only.Editor;
        this.pendingOnlyOfficeSaveKey = key;
        this.pendingOnlyOfficeSave = this.waitForOnlyOfficeSync(editor, key)
            .then(async () => {
                const revision = this.only.getEditRevision();
                await this.medicalProvider.saveDocumentConfirmed(
                    document.id,
                    key,
                    this.only.wasModifiedInCurrentSession(),
                );
                if (this.only.Editor !== editor
                        || !this.only.markRevisionSaved(key, revision)) {
                    throw new Error("O documento foi alterado durante o salvamento. Salve novamente.");
                }
            })
            .finally(() => {
                if (this.pendingOnlyOfficeSaveKey === key) {
                    this.pendingOnlyOfficeSave = null;
                    this.pendingOnlyOfficeSaveKey = null;
                }
            });
        return this.pendingOnlyOfficeSave;
    }

    async saveDocumentOnlyOffice(): Promise<void> {
        this.progressBar.show();
        try {
            if (this.isOnlyOfficeDocument(this.document)) {
                await this.persistOnlyOfficeDocument(this.document);
            } else {
                await this.medicalProvider.onRequestSaveAs(this.configonly.key);
            }
            this.snackBar.successMessage("Documento salvo com sucesso!");
        } catch (error) {
            console.error("Erro ao salvar documento:", error);
            console.error( 
                error?.error?.message || error?.message ||
                    "O salvamento não foi confirmado. Tente novamente.",
            );
        } finally {
            this.progressBar.hide();
        }
    }

    insert(format: string, documentModel: any) {
        if (this.isButtonDisabled) {
            return;
        }

        this.isButtonDisabled = true;

        if (
            (format == "html" && this.documentForm.value == null) ||
            this.documentForm.value == ""
        ) {
            this.medicalProvider
                .onRequestSaveAs(this.configonly.key)
                .then(() => {
                    this.snackBar.successMessage("Dados salvos com sucesso!");
                })
                .catch(() => {
                    this.snackBar.warnMessage(
                        "Dados não salvos, contate a focus!",
                    );
                });
            return;
        }

        let data = new Document();

        if (this.documentModel?.id) {
            documentModel = this.documentModel;

            if (documentModel.footer) {
                data.footerId = documentModel.footer.id;
            }
            if (documentModel.header) {
                data.headerId = documentModel.header.id;
            }
        }

        data.id = this.document?.id ? this.document.id : null;
        data.dateAt = this.data.dateSchedule;
        data.dateAt = this.document?.id
            ? this.document.dateAt
            : moment(this.data.dateSchedule).format("YYYY-MM-DD");
        data.companyCostCenter = null;
        data.performer = { id: this.data.performer.id };
        data.patient = { id: this.data.patient.id };
        data.insurance = { id: this.data.patient.insurance.id };
        data.speciality = { id: this.specialityControl.value.id };
        data.company = CwUtils.extractId(this.data.company);
        data.type = this.typeDocument;
        data.documentBasic = `<html>${this.documentForm.value}</html>`;
        data.format = format;

        data.documentModel = CwUtils.extractId(documentModel);
        data.editing = true;
        data.title = `Documento_${this.data.patient.id}`;

        if (documentModel == null) {
            this.medicalProvider.insert(data).then((response) => {
                this.snackBar.successMessage(response.body.message);
                this.document = response.body.data;
                this.getDocuments();

                if (
                    this.document.format == "docx" ||
                    this.document.format == "rtf"
                ) {
                    this.openExpression();
                }

                const width = window.innerWidth;

                this.historyDocument();
            });
        } else {
            this.medicalProvider.newDocument(data).then((response) => {
                this.snackBar.successMessage(response.body.message);
                this.document = response.body.data;
                this.getDocuments();

                if (
                    this.document.format == "docx" ||
                    this.document.format == "rtf"
                ) {
                    this.openExpression();
                }

                const width = window.innerWidth;

                this.historyDocument();
            });
        }

        setTimeout(() => {
            this.isButtonDisabled = false;
        }, 3000);
    }

    insertAutomatic(format: string, documentModel: any) {
        if (
            (format == "html" && this.documentForm.value == null) ||
            this.documentForm.value == ""
        ) {
            this.snackBar.warnMessage("Preencha os campos texto!");
            return;
        }

        let data = new Document();
        data.id = this.document?.id ? this.document.id : null;
        data.dateAt = this.data.dateSchedule;
        data.dateAt = this.document?.id
            ? this.document.dateAt
            : moment(data.dateAt).format("YYYY-MM-DD");
        data.companyCostCenter = null;
        data.performer = { id: this.data.performer.id };
        data.patient = { id: this.data.patient.id };
        data.insurance = { id: this.data.patient.insurance.id };
        data.speciality = { id: this.specialityControl.value.id };
        data.company = CwUtils.extractId(this.data.company);
        data.type = this.typeDocument;

        data.documentBasic = `<html>${this.documentForm.value}</html>`;
        data.format = format;

        if (this.documentModel?.id) {
            documentModel = this.documentModel;

            if (documentModel.footer) {
                data.footerId = documentModel.footer.id;
            }
            if (documentModel.header) {
                data.headerId = documentModel.header.id;
            }
        }

        data.documentModel = CwUtils.extractId(documentModel);
        data.editing = true;
        data.title = `Documento_${this.data.patient.id}`;

        this.medicalProvider.insert(data).then((response) => {
            if (!this.document.id) {
                this.getDocuments();
            }

            this.document = response.body.data;

            if (
                this.document.format == "docx" ||
                this.document.format == "rtf"
            ) {
                this.openExpression();
            }
        });
    }

    getDocumentById(idRequestModel) {
        this.medicalProvider.getById(idRequestModel).then((response) => {
            if (this.isDestroyed) {
                return;
            }

            this.document = response.body;

            if (this.document.type == this.typeDocument) {
                this.validateDocumentSignature(this.document);
                this.cidListSelected = response.body.documentDiagnosisList;
                if (this.document.speciality?.id) {
                    this.specialityControl.setValue(this.document.speciality);
                }

                if (
                    this.document.format == "docx" ||
                    this.document.format == "rtf"
                ) {
                    if (!this.document.editing) {
                        this.configonly.edit = false;
                    }

                    if (this.document.signed == null) {
                        this.loadDocument();
                    }
                } else {
                    /* if (!this.document.editing) {
                    this.documentForm.disable();
                }*/

                    const html = decodeURIComponent(
                        escape(window.atob(response.body.document)),
                    );

                    // remove <html> caso venha assim
                    const cleanHtml = html
                        .replace(/^<html>/i, "")
                        .replace(/<\/html>$/i, "");

                    this.loadingSavedDocument = true;

                    if (this.quillInstance) {
                        this.quillInstance.clipboard.dangerouslyPasteHTML(
                            cleanHtml,
                        );
                    } else {
                        this.documentForm.setValue(cleanHtml, {
                            emitEvent: false,
                        });
                    }

                    this.loadingSavedDocument = false;
                    this.only.alterDocumentStateSubject(false);
                }
            } else {
                this.signatureValidation = null;
                this.newDocument();
            }
        });
    }

    private validateDocumentSignature(document: any): Promise<any> {
        if (!document?.id || !document?.signed) {
            if (this.document?.id === document?.id) {
                this.signatureValidation = null;
            }
            this.signatureValidationLoading = false;
            return Promise.resolve(null);
        }

        this.signatureValidationLoading = true;

        return this.medicalProvider
            .validateSignature(document.id)
            .then((validation) => {
                if (this.document?.id === document.id) {
                    this.signatureValidation = validation;
                }

                return validation;
            })
            .catch((err) => {
                const validation = {
                    valid: false,
                    message:
                        err?.error?.message ||
                        "Não foi possível validar a assinatura digital do PDF.",
                };

                if (this.document?.id === document.id) {
                    this.signatureValidation = validation;
                }

                return validation;
            })
            .finally(() => {
                if (this.document?.id === document.id) {
                    this.signatureValidationLoading = false;
                }
            });
    }

    observableModels() {
        this.modelsControl.valueChanges.pipe().subscribe((res) => {
            if (res.format == "docx" || this.document.format == "rtf") {
                this.insert("docx", res);

                /* const confirmDialogRef = this.dialog.open(
                    FuseConfirmDialogComponent,
                    {
                        disableClose: false,
                    }
                );

                confirmDialogRef.componentInstance.action = "delete";
                confirmDialogRef.componentInstance.deleteMessage = `Deseja criar um documento a partir do modelo ${res.title}?`;

                confirmDialogRef.afterClosed().subscribe((result) => {
                    if (result) {
                        this.insert("docx", res);
                    }
                });
*/
            } else if (res.id) {
                this.documentModel = res;
                this.documentForm.setValue(null);
                this.medicalProvider
                    .getTextByModel(
                        res.id,
                        this.data.patient.id,
                        this.data.performer.id,
                    )
                    .then((response) => {
                        console.log(response);
                        this.documentForm.setValue(
                            decodeURIComponent(response.body),
                        );
                    });
            } else {
                this.modelsPageOptions.argument = res;
                this.getModelsType(this.data.type);
            }
        });
    }

    ObservableFormat() {
        this.documentForm.valueChanges
            .pipe(
                takeUntil(this._unsubscribeAll),
                debounceTime(700),
                distinctUntilChanged(),
            )
            .subscribe((res) => {
                this.document.documentBasic = res;

                if (this.document.id) {
                    this.insertAutomatic("html", null);
                }

                if (
                    this.document.id == null &&
                    this.documentForm.value != null
                ) {
                    if (this.isButtonDisabled) {
                        return;
                    }
                    this.isButtonDisabled = true;

                    setTimeout(() => {
                        this.isButtonDisabled = false;
                    }, 3000);
                    this.insertAutomatic("html", null);
                }
            });
    }

    getDocuments(event?, type?) {
        switch (type) {
            case "short":
                this.pageOptions.fieldSort = event.active;
                this.pageOptions.sortDirection = event.direction;
                break;
            case "page":
                this.pageOptions.page = event.pageIndex;
                this.pageOptions.sizePage = event.pageSize;
                break;

            default:
                this.pageOptions.page = 0;
                this.pageOptions.sizePage = 5;
                break;
        }

        this.pageOptions.fieldSort = "dateAt";
        this.pageOptions.sortDirection = "desc";
        this.progressBar.show();
        this.medicalProvider
            .getPage(
                this.pageOptions,
                this.data.patient.id,
                this.data.type,
                this.data.performer.id,
            )
            .then((document) => {
                this.data.documentList = document.body.content;
                const dados = document.body;
                this.totalElements = dados.totalElements;
                this.pagina = dados.number;
                /*
                if (
                    this.data.documentList &&
                    this.data.documentList.length > 0
                ) {
                    const firstDoc = this.data.documentList[0];

                    const today = moment(new Date()).format("YYYY-MM-DD");                 
                    const docDate = moment(firstDoc.dateAt).format(
                        "YYYY-MM-DD"
                    );

                    if (docDate === today) {
                        this.getDocumentById(firstDoc.id);
                    }else{
                        
                    }
                }*/
                this.only.alterDocumentStateSubject(false);

                this.progressBar.hide();
            })
            .catch((error) => {
                this.progressBar.hide();
            });
    }

    public loadDocument() {
        this.configurationOnly();
        this.openonly();
    }

    destroy() {
        this.only.onDestroyEditor();
    }

    openonly() {
        if (this.document?.id != null) {
            this.only.load(); //carregando o documento

            setTimeout(() => {
                this.only.сonnectEditor(this.configonly);
            }, 1000);
        }
    }

    printOnly() {
        this.only.onDestroyEditor(this.editor);
    }

    configurationOnly() {
        let usuario = JSON.parse(localStorage.getItem("user"));
        const mobileView = this.isMobileView();
        this.configonly.author = "ClinicAll";
        this.configonly.name = "ClinicAll";
        this.configonly.height = "100%";
        this.configonly.zoom = -2;
        this.configonly.type = mobileView ? "mobile" : "desktop";
        this.configonly.mobile = mobileView
            ? {
                  forceView: false,
                  info: false,
                  standardView: false,
                  disableForceDesktop: true,
              }
            : null;
        this.configonly.mobileForceView = mobileView ? false : null;
        this.configonly.toolbar = false;
        this.configonly.statusBar = false;
        this.configonly.edit = mobileView
            ? !this.document.signed
            : this.document.editing !== false;
        this.configonly.mode = this.configonly.edit ? "edit" : "view";
        this.configonly.container = "docx";

        if (this.typeDocument == 4) {
            this.configonly.hideRulers = true;
            this.configonly.hideRightMenu = true;
        }

        if (this.document?.id) {
            this.configonly.url = `${this.baseUrl}document/download/${
                this.document.id
            }?medico=${this.document.performer.id}&paciente=${
                this.document.patient.id
            }&sistema=${1}&X-Auth-Token=${localStorage.getItem("token")}`;
            this.configonly.callbackUrl = `${
                this.baseUrl
            }document/track?fileName=${
                this.document.id
            }&X-Auth-Token=${localStorage.getItem("token")}`;

            var hash = Math.floor(Date.now() * Math.random()).toString(36);

            this.configonly.key = `${hash}_` + this.document.id;
        }
    }

    @HostListener("window:resize", ["$event"]) onResize(event) {
        this.innerWidth = window.innerWidth;
    }

    @HostListener("document:keydown.escape", ["$event"])
    onEscape(event: KeyboardEvent) {
        if (this.quillFullscreen) {
            this.setQuillFullscreen(false);
        }
        if (this.onlyOfficeFullscreenMode) {
            this.setOnlyOfficeFullscreen(null);
        }
    }

    @HostListener("document:fullscreenchange")
    onFullscreenChange() {
        if (
            this.onlyOfficeFullscreenMode === "screen" &&
            !document.fullscreenElement
        ) {
            this.setOnlyOfficeFullscreen(null, false);
        }
    }

    isMobileView(): boolean {
        return (this.innerWidth || window.innerWidth) < 960;
    }

    toggleQuillFullscreen(event?: Event) {
        if (event) {
            event.stopPropagation();
        }

        this.setQuillFullscreen(!this.quillFullscreen);
    }

    private setQuillFullscreen(active: boolean) {
        this.quillFullscreen = active;
        document.body.classList.toggle(
            "patient-evolution-quill-fullscreen",
            active,
        );
        this.syncSafariEditorFullscreenClass();
    }

    toggleOnlyOfficeFullscreen(event?: Event) {
        this.toggleOnlyOfficeScreenFullscreen(event);
    }

    toggleOnlyOfficeTabFullscreen(event?: Event) {
        if (event) {
            event.stopPropagation();
        }

        this.setOnlyOfficeFullscreen(
            this.onlyOfficeFullscreenMode === "tab" ? null : "tab",
        );
    }

    toggleOnlyOfficeScreenFullscreen(event?: Event) {
        if (event) {
            event.stopPropagation();
        }

        this.setOnlyOfficeFullscreen(
            this.onlyOfficeFullscreenMode === "screen" ? null : "screen",
        );
    }

    private setOnlyOfficeFullscreen(
        mode: "tab" | "screen" | null | boolean,
        syncNativeFullscreen: boolean = true,
    ) {
        const normalizedMode =
            typeof mode === "boolean" ? (mode ? "screen" : null) : mode;

        this.onlyOfficeFullscreenMode = normalizedMode;
        this.onlyOfficeFullscreen = normalizedMode === "screen";
        document.body.classList.toggle(
            "patient-evolution-onlyoffice-tab-fullscreen",
            normalizedMode === "tab",
        );
        document.body.classList.toggle(
            "patient-evolution-onlyoffice-fullscreen",
            normalizedMode === "screen",
        );
        this.syncSafariEditorFullscreenClass();
        this.syncNativeOnlyOfficeFullscreen(normalizedMode, syncNativeFullscreen);
        this.refreshOnlyOfficeLayout();
    }

    private syncSafariEditorFullscreenClass() {
        document.body.classList.toggle(
            "safari-editor-fullscreen",
            this.isSafariBrowser() &&
                (this.quillFullscreen || this.onlyOfficeFullscreenMode === "screen"),
        );
    }

    private syncNativeOnlyOfficeFullscreen(
        mode: "tab" | "screen" | null,
        syncNativeFullscreen: boolean,
    ) {
        if (!syncNativeFullscreen) {
            return;
        }

        const nativeFullscreenElement = document.fullscreenElement;
        const shell = this.onlyOfficeShell?.nativeElement;

        if (mode === "screen" && shell?.requestFullscreen) {
            if (nativeFullscreenElement !== shell) {
                shell.requestFullscreen().catch(() => null);
            }
            return;
        }

        if (
            nativeFullscreenElement &&
            nativeFullscreenElement === shell &&
            document.exitFullscreen
        ) {
            document.exitFullscreen().catch(() => null);
        }
    }

    private isSafariBrowser(): boolean {
        const userAgent = navigator.userAgent || "";
        const vendor = navigator.vendor || "";

        return (
            /Apple/i.test(vendor) &&
            /Safari/i.test(userAgent) &&
            !/Chrome|Chromium|CriOS|FxiOS|Edg|OPR|Android/i.test(userAgent)
        );
    }

    private refreshOnlyOfficeLayout() {
        setTimeout(() => {
            window.dispatchEvent(new Event("resize"));
        });
    }

    openExpression() {
        this.destroy();
        this.expressionProvider
            .checkDocumentModelIsExpression(this.document.documentModel.id)
            .then((check) => {
                if (check.data == true) {
                    const confirmDialogRef = this.dialog.open(
                        CalculateFormulasComponent,
                        {
                            data: {
                                documentModel: this.document.documentModel.id,
                                document: this.document.id,
                            },
                            width: "80%",
                            disableClose: true,
                        },
                    );
                    confirmDialogRef.afterClosed().subscribe((result) => {
                        this.medicalProvider
                            .documentFromExpression(this.document)
                            .then((documentFromExpresison) => {
                                if (documentFromExpresison.body.data.id) {
                                    this.loadDocument();
                                }
                            });
                    });
                } else {
                    this.loadDocument();
                }
            });
    }

    checkExpression() {
        if (this.document.id) {
            this.expressionProvider
                .checkDocumentExpressionExists(this.document.id)
                .then((check) => {
                    if (check.data == true) {
                        this.only.onDestroyEditor();
                        this.openExpression();
                    } else {
                        return false;
                    }
                });
        }
    }

    toggleHistoryPatient() {
        this.showPatientInfoMobile = false;
        this.toggleHistory = !this.toggleHistory;
    }

    returnToAnamnese() {
        if (this.isMobileView()) {
            this.pdfHistory = false;
            this.pdfHistorySrcFHD = null;
            this.pdfHistorySrcHD = null;
            this.toggleHistory = false;
            this.showPatientInfoMobile = false;
        }
        this.sizeClassHistory = 95;
    }

    togglePatientInfoMobile() {
        this.showPatientInfoMobile = !this.showPatientInfoMobile;
    }

    repeatDocument() {
        this.progressBar.show();

        const confirmDialogRef = this.dialog.open(FuseConfirmDialogComponent, {
            disableClose: false,
        });

        confirmDialogRef.componentInstance.action = "delete";
        confirmDialogRef.componentInstance.deleteMessage =
            "Deseja repetir essa solicitação?";

        confirmDialogRef.afterClosed().subscribe((result) => {
            if (result) {
                this.medicalProvider
                    .repeatDocument(this.document.id, this.data.performer.id)
                    .then((res) => {
                        if (
                            res.body.data.format == "docx" ||
                            res.body.data.format == "rtf"
                        ) {
                            this.destroy();
                        }
                        this.progressBar.hide();
                        this.getDocuments();
                        this.getDocumentById(res.body.data.id);
                    });
            } else {
                this.progressBar.hide();
            }
        });
    }

    printItem(event: Event, document, download?) {
        this.stopPropagation(event);
        this.isButtonDisabled = true;
        this.pdfSrc = null;
        this.pdfHistorySrcFHD = null;
        this.pdfHistory = null;
        this.pdfHistorySrcHD = null;
        this.progressBar.show();

        try {
            if (document.format == "docx" || document.format == "rtf") {
                this.persistOnlyOfficeDocument(document)
                    .then(() => {
                            this.medicalProvider
                                .generateRequestPdfByGcp(
                                    document.id,
                                    this.data.performer.id,
                                    this.data.patient.id,
                                )
                                .then((x) => {
                                    let pdf = x.pdf as string;
                                    var newBlob = new Blob([x], {
                                        type: "application/pdf",
                                    });
                                    const nav = window.navigator as any;

                                    if (nav && nav.msSaveOrOpenBlob) {
                                        nav.msSaveOrOpenBlob(newBlob);
                                        this.isButtonDisabled = false;
                                        return;
                                    }

                                    const data =
                                        window.URL.createObjectURL(newBlob);

                                    this.progressBar.hide();
                                    const dialogRef = this.dialog.open(
                                        PrintGcpComponent,
                                        {
                                            height: "80%",
                                            width: "80%",
                                            data: { pdf },
                                            restoreFocus: false,
                                        },
                                    );

                                    dialogRef.afterClosed().subscribe(() => {
                                        this.pdfSrc = null;
                                    });

                                    if (download) {
                                        const link =
                                            document.createElement("a");
                                        link.href = data;
                                        link.download = "Guia Teste.pdf";
                                        link.dispatchEvent(
                                            new MouseEvent("click", {
                                                bubbles: true,
                                                cancelable: true,
                                                view: window,
                                            }),
                                        );

                                        setTimeout(() => {
                                            window.URL.revokeObjectURL(data);
                                            link.remove();
                                        }, 100);
                                    }

                                    this.isButtonDisabled = false;
                                })
                                .catch((err) => {
                                    console.error("Erro ao gerar PDF", err);
                                    this.isButtonDisabled = false;
                                    this.progressBar.hide();
                                });
                    })
                    .catch((err) => {
                        console.error("Erro ao salvar", err);
                        this.snackBar.warnMessage("O documento não foi salvo. A impressão foi cancelada.");
                        this.isButtonDisabled = false;
                        this.progressBar.hide();
                    });
            } else {
                this.medicalProvider
                    .generateRequestPdfByGcp(
                        document.id,
                        this.data.performer.id,
                        this.data.patient.id,
                    )
                    .then((x) => {
                        let pdf = x.pdf as string;
                        var newBlob = new Blob([x], {
                            type: "application/pdf",
                        });
                        const nav = window.navigator as any;

                        if (nav && nav.msSaveOrOpenBlob) {
                            nav.msSaveOrOpenBlob(newBlob);
                            this.isButtonDisabled = false;
                            return;
                        }

                        const data = window.URL.createObjectURL(newBlob);

                        this.progressBar.hide();
                        const dialogRef = this.dialog.open(PrintGcpComponent, {
                            height: "80%",
                            width: "80%",
                            data: { pdf },
                            restoreFocus: false,
                        });

                        dialogRef.afterClosed().subscribe(() => {
                            this.pdfSrc = null;
                        });

                        if (download) {
                            const link = document.createElement("a");
                            link.href = data;
                            link.download = "Guia Teste.pdf";
                            link.dispatchEvent(
                                new MouseEvent("click", {
                                    bubbles: true,
                                    cancelable: true,
                                    view: window,
                                }),
                            );

                            setTimeout(() => {
                                window.URL.revokeObjectURL(data);
                                link.remove();
                            }, 100);
                        }

                        this.isButtonDisabled = false;
                    })
                    .catch((err) => {
                        console.error("Erro ao gerar PDF", err);
                        this.isButtonDisabled = false;
                        this.progressBar.hide();
                    });
            }
        } catch (err) {
            console.error("Erro inesperado", err);
            this.isButtonDisabled = false;
            this.progressBar.hide();
        }
    }

    async sendEmailPdf(
        event: Event,
        document: any,
        download?: any,
    ): Promise<void> {
        this.stopPropagation(event);

        const confirmDialogRef = this.dialog.open(FuseConfirmDialogComponent, {
            disableClose: false,
        });

        let message = "Deseja enviar esse documento para o e-mail do paciente?";
        if (document.signed == null) {
            message =
                "O documento ainda não foi assinado. Deseja enviar ele para o e-mail do paciente?";
        }

        confirmDialogRef.componentInstance.action = "delete";
        confirmDialogRef.componentInstance.deleteMessage = message;

        confirmDialogRef.afterClosed().subscribe(async (result) => {
            if (!result) {
                return;
            }

            this.isButtonDisabled = true;
            this.progressBar.show();

            try {
                const validation = await this.validateDocumentSignature(document);

                if (!validation?.valid) {
                    this.snackBar.warnMessage(
                        "A assinatura digital não está válida. O e-mail não foi enviado.",
                    );
                    return;
                }

                await this.persistOnlyOfficeDocument(document);

                await this.medicalProvider.sendEmailWithPdfAttachment(
                    document.id,
                    this.data.performer.id,
                    this.data.patient.id,
                );

                console.log("E-mail enviado com sucesso!");
            } catch (err) {
                this.snackBar.warnMessage(
                    err?.error?.message || "Não foi possível enviar o e-mail.",
                );
                console.error("Erro ao enviar e-mail com PDF", err);
            } finally {
                this.isButtonDisabled = false;
                this.progressBar.hide();
            }
        });
    }

    checkProfessional(id) {
        if (this.data.performer.id == id) {
            return true;
        } else {
            return false;
        }
    }

    getMainImage() {
        if (this.data.patient.id) {
            this.patientEditProvider
                .getImageMain(this.data.patient.id)
                .then((res) => {
                    this.showImg(res.body.content);
                    // this.imageMain = res.body;
                });
        }
    }

    showImg(file) {
        if (file) {
            this.imagePath = this._sanitizer.bypassSecurityTrustResourceUrl(
                "data:image/jpg;base64," + file,
            );
        }
    }

    getSpeciality(professionalInputId?) {
        let professionalId = this.data.performer.professional.id;

        if (!professionalId) {
            return;
        }

        this.attendanceListProvider
            .getSpeciality(professionalId, this.specialityPageOptions)
            .then((res) => {
                if (this.specialityList.length == 0) {
                    this.specialityList = res.body.content;
                    this.specialityControl.setValue(this.specialityList[0], {
                        emitEvent: false,
                    });
                } else {
                    this.specialityList = res.body.content;
                }
            });
    }

    setSpeciality(speciality) {}

    displayGenericFn(object?: any): string | undefined {
        if (!object) {
            return "";
        }
        return object.name ? object.name : "";
    }

    viewDocument(event: Event, document: any) {
        this.stopPropagation(event);
        console.log(document);

        if (this.isMobileView()) {
            this.pdfHistory = false;
            this.pdfHistorySrcFHD = null;
            this.pdfHistorySrcHD = null;
            this.toggleHistory = false;
            this.showPatientInfoMobile = false;
        }

        if (this.document.format == "docx" || this.document.format == "rtf") {
            this.destroy();
        }
        this.getDocumentById(document.id);
    }

    newDocument() {
        this.document = new Document();
        this.documentForm.setValue(null);
        this.modelsControl.setValue(null);
        this.documentModel = null;
        this.modelsControl.enable();
    }

    hideReport() {
        if (this.pdfHistory) {
            this.pdfHistory = false;
            this.pdfHistorySrcFHD = null;
            this.pdfHistorySrcHD = null;
            this.toggleHistory = true;
            this.sizeClassHistory = 95;
            return;
        }
    }

    generateReportFHD(
        patientId: any,
        dateStart?: any,
        dateEnd?: any,
        download?: boolean,
    ) {
        this.sizeScreen = "FHD";
        this.pdfHistorySrcFHD = null;
        this.pdfHistory = true;
        this.toggleHistory = false;
        this.showPatientInfoMobile = false;
        this.loading = true;
        this.sizeClassHistory = 50;
        console.log("Imprindo...");
        setTimeout(() => {
            this.medicalProvider
                .generatePdfAnamneseByGcp(
                    patientId,
                    this.data.performer.id,
                    this.typeDocument,
                    dateStart,
                    dateEnd,
                )
                .then((x) => {
                    console.log("Imprindo...");
                    this.pdfHistorySrcFHD = x.pdf as string;
                    this.loading = false;
                    var newBlob = new Blob([x], { type: "application/pdf" });
                    const nav = window.navigator as any;
                    if (nav && nav.msSaveOrOpenBlob) {
                        nav.msSaveOrOpenBlob(newBlob);
                        return;
                    }
                    const data = window.URL.createObjectURL(newBlob);

                    if (!download) {
                        return false;
                    }

                    var link = document.createElement("a");
                    link.href = data;
                    link.download = "Guia Teste.pdf";
                    link.dispatchEvent(
                        new MouseEvent("click", {
                            bubbles: true,
                            cancelable: true,
                            view: window,
                        }),
                    );

                    setTimeout(function () {
                        window.URL.revokeObjectURL(data);
                        link.remove();
                    }, 100);
                });
        }, 1000);
    }

    generateReportHD(
        patientId: any,
        dateStart?: any,
        dateEnd?: any,
        download?: boolean,
    ) {
        this.sizeScreen = "HD";
        this.pdfHistorySrcHD = null;
        this.pdfHistory = true;
        this.toggleHistory = false;
        this.showPatientInfoMobile = false;
        this.loading = true;
        this.sizeClassHistory = 50;
        console.log("Imprindo...");
        setTimeout(() => {
            this.medicalProvider
                .generatePdfAnamneseByGcp(
                    patientId,
                    this.data.performer.id,
                    this.typeDocument,
                    dateStart,
                    dateEnd,
                )
                .then((x) => {
                    console.log("Imprindo...");
                    this.pdfHistorySrcHD = x.pdf as string;
                    this.loading = false;
                    var newBlob = new Blob([x], { type: "application/pdf" });
                    const nav = window.navigator as any;
                    if (nav && nav.msSaveOrOpenBlob) {
                        nav.msSaveOrOpenBlob(newBlob);
                        return;
                    }
                    const data = window.URL.createObjectURL(newBlob);

                    if (!download) {
                        return false;
                    }

                    var link = document.createElement("a");
                    link.href = data;
                    link.download = "Guia Teste.pdf";
                    link.dispatchEvent(
                        new MouseEvent("click", {
                            bubbles: true,
                            cancelable: true,
                            view: window,
                        }),
                    );

                    setTimeout(function () {
                        window.URL.revokeObjectURL(data);
                        link.remove();
                    }, 100);
                });
        }, 1000);
    }

    formatLabel(value: number): string {
        return value.toString(); // ou `${value}%`, se quiser mostrar como porcentagem
    }

    printHistory(
        patientId: any,
        dateStart?: any,
        dateEnd?: any,
        download?: boolean,
    ) {
        this.sizeScreen = "FHD";
        this.pdfHistorySrcFHD = null;
        this.pdfHistory = true;
        this.toggleHistory = false;
        this.showPatientInfoMobile = false;
        this.loading = true;
        this.sizeClassHistory = 50;
        console.log("Imprindo...");
        setTimeout(() => {
            this.medicalProvider
                .generatePdfHistoryByGcp(
                    patientId,
                    this.data.performer.id,
                    this.typeDocument,
                    dateStart,
                    dateEnd,
                )
                .then((x) => {
                    console.log("Imprindo...");
                    this.pdfHistorySrcFHD = x.pdf as string;
                    this.loading = false;
                    var newBlob = new Blob([x], { type: "application/pdf" });
                    const nav = window.navigator as any;
                    if (nav && nav.msSaveOrOpenBlob) {
                        nav.msSaveOrOpenBlob(newBlob);
                        return;
                    }
                    const data = window.URL.createObjectURL(newBlob);

                    if (!download) {
                        return false;
                    }

                    var link = document.createElement("a");
                    link.href = data;
                    link.download = "Guia Teste.pdf";
                    link.dispatchEvent(
                        new MouseEvent("click", {
                            bubbles: true,
                            cancelable: true,
                            view: window,
                        }),
                    );

                    setTimeout(function () {
                        window.URL.revokeObjectURL(data);
                        link.remove();
                    }, 100);
                });
        }, 1000);
    }

    printHistoryHD(
        patientId: any,
        dateStart?: any,
        dateEnd?: any,
        download?: boolean,
    ) {
        this.sizeScreen = "FHD";
        this.pdfHistorySrcFHD = null;
        this.pdfHistory = true;
        this.toggleHistory = false;
        this.showPatientInfoMobile = false;
        this.loading = true;
        this.sizeClassHistory = 50;
        console.log("Imprindo...");
        setTimeout(() => {
            this.medicalProvider
                .generatePdfHistoryByGcp(
                    patientId,
                    this.data.performer.id,
                    this.typeDocument,
                    dateStart,
                    dateEnd,
                )
                .then((x) => {
                    console.log("Imprindo...");
                    this.pdfHistorySrcHD = x.pdf as string;
                    this.loading = false;
                    var newBlob = new Blob([x], { type: "application/pdf" });
                    const nav = window.navigator as any;
                    if (nav && nav.msSaveOrOpenBlob) {
                        nav.msSaveOrOpenBlob(newBlob);
                        return;
                    }
                    const data = window.URL.createObjectURL(newBlob);

                    if (!download) {
                        return false;
                    }

                    var link = document.createElement("a");
                    link.href = data;
                    link.download = "Guia Teste.pdf";
                    link.dispatchEvent(
                        new MouseEvent("click", {
                            bubbles: true,
                            cancelable: true,
                            view: window,
                        }),
                    );

                    setTimeout(function () {
                        window.URL.revokeObjectURL(data);
                        link.remove();
                    }, 100);
                });
        }, 1000);
    }

    openAttachment() {
        this.pdfSrc = null;
        this.pdfHistorySrcFHD = null;
        const confirmDialogRef = this.dialog.open(PatientAttachmentComponent, {
            data: {
                type: this.typeDocument,
                nameDocument: "Anexos",
                //documentList: this.documentList,
                patient: this.data?.patient,
                performer: this.data?.performer,
                dateSchedule: this.data?.dateSchedule,
            },
            width: "100%",
            maxWidth: "100%",
            height: "100%",

            disableClose: true,
        });

        confirmDialogRef.afterClosed().subscribe((result) => {});
    }

    observableDate() {
        this.range.controls["end"].valueChanges.pipe().subscribe((res) => {
            if (res) {
                let dateStart = moment(
                    this.range.controls["start"].value,
                ).format("YYYY-MM-DD");
                let dateEnd = moment(res).format("YYYY-MM-DD");

                if (this.sizeScreen == "FHD") {
                    this.generateReportFHD(
                        this.data.patient.id,
                        dateStart,
                        dateEnd,
                    );
                }

                if (this.sizeScreen == "HD") {
                    this.generateReportHD(
                        this.data.patient.id,
                        dateStart,
                        dateEnd,
                    );
                }
            }
        });
    }

    colorDefault() {
        const quillInstance = this.quillEditor?.quillEditor; // Obtém a instância do Quill

        if (quillInstance) {
            quillInstance.clipboard.addMatcher(
                Node.ELEMENT_NODE,
                (node, delta) => {
                    delta.ops.forEach((op) => {
                        if (op.attributes) {
                            delete op.attributes.color; // Remove a cor
                        }
                    });
                    return delta;
                },
            );
        } else {
            console.error("Quill instance not found");
        }
    }

    openCapture() {
        this.pdfSrc = null;
        const confirmDialogRef = this.dialog.open(PatientCaptureComponent, {
            data: {
                type: "document",
                patient: this.data.patient,
                performer: this.data.performer,
                dateSchedule: this.data.dateSchedule,
                document: this.document,
            },
            width: "100%",
            maxWidth: "100%",
            height: "100%",
            maxHeight: "100vh",
            disableClose: true,
        });

        confirmDialogRef.afterClosed().subscribe((result) => {});
    }

    cidRemove(cid) {
        let cidIindex;
        this.cidListSelected.forEach((item, index) => {
            if (item.cid.id === cid.cid.id) {
                cidIindex = index;
                return;
            }
        });
        this.cidListSelected.splice(cidIindex, 1);
        if (cid.main == true) {
            this.cidListSelected[0].main = true;
        }

        if (this.document.id) {
            this.medicalProvider.deleteDocumentCid(
                cid.cid.id,
                this.document.id,
            );
        }
    }

    cidMain(cid) {
        this.cidListSelected.forEach((item) => {
            if (item.cid.id === cid.cid.id) {
                item.main = true;
            } else {
                item.main = false;
            }
        });
    }

    cidSelected(cid) {
        let cidDiagnosis = new OrderDiagnosis();
        let exist = false;
        cidDiagnosis.cid = cid.option.value;

        if (this.cidListSelected.length) {
            this.cidListSelected.forEach((cidFromList) => {
                if (cidFromList.cid.id == cidDiagnosis.cid.id) {
                    exist = true;
                }
            });
        }

        if (exist) {
            this.snackBar.warnMessage("Cid já Selecionado");
            this.cidFormControl.setValue(null);
            return;
        } else {
            this.cidListSelected.push(cidDiagnosis);
        }
        this.cidListSelected.length == 1
            ? (this.cidListSelected[0].main = true)
            : "";
        this.cidInput.nativeElement.value = "";
        this.cidFormControl.setValue(null);
        console.log(this.cidListSelected);

        if (this.cidListSelected.length > 0 && this.document.id) {
            this.medicalProvider
                .insertDocumentCid(this.cidListSelected, this.document.id)
                .then((res) => {
                    console.log(res);
                });
        }
    }

    getCids() {
        this.attendanceListProvider.getCids(this.cidPageOptions).then((res) => {
            this.CIDList = res.body.content;
        });
    }

    filterCid() {
        this.cidFormControl.valueChanges
            .pipe(
                takeUntil(this._unsubscribeAll),
                debounceTime(500),
                distinctUntilChanged(),
            )
            .subscribe((res) => {
                if (res && res.id) {
                    this.cidPageOptions.argument = res.name;
                } else if (res && typeof res === "string") {
                    this.cidPageOptions.argument = res;
                } else {
                    this.cidPageOptions.argument = "";
                    //this.osHeaderForm.controls["cidHeaderOs"].setValue(null);
                }

                this.getCids();
            });
    }

    getDocumentDiagnosisById() {
        let document = JSON.parse(localStorage.getItem("document"));

        if (document?.id) {
            this.medicalProvider
                .getDocumentDiagnosis(document.id)
                .then((res) => {
                    console.log(res);

                    if (res.length > 0) {
                        this.processType = true;
                    } else {
                        this.processType = false;
                    }

                    this.cidListSelected = res;
                });
        }
    }

    onEditorCreated(quill: Quill) {
        this.quillInstance = quill;

        setTimeout(() => {
            quill.focus();
        }, 0);

        quill.clipboard.addMatcher(Node.ELEMENT_NODE, (node, delta) => {
            if (this.loadingSavedDocument) {
                return delta;
            }

            const newDelta = new Delta();

            delta.ops.forEach((op) => {
                const attrs = { ...op.attributes };

                delete attrs.color;
                delete attrs.background;

                if (node instanceof HTMLElement) {
                    const fontWeight = node.style.fontWeight;

                    if (
                        fontWeight === "bold" ||
                        Number(fontWeight) >= 600 ||
                        node.tagName === "B" ||
                        node.tagName === "STRONG"
                    ) {
                        attrs.bold = true;
                    }
                }

                newDelta.insert(op.insert, attrs);
            });

            return newDelta;
        });
    }

    toggleDocumentSelection(document: any, checked: boolean): void {
        if (checked) {
            if (!this.isDocumentSelected(document)) {
                this.selectedDocuments.push(document);
            }
            return;
        }

        this.selectedDocuments = this.selectedDocuments.filter(
            (selected) => selected.id !== document.id,
        );
    }

    isDocumentSelected(document: any): boolean {
        return this.selectedDocuments.some(
            (selected) => selected.id === document.id,
        );
    }

    printDocumentsList() {
        this.isButtonDisabled = true;
        this.pdfSrc = null;
        this.pdfHistorySrcFHD = null;
        this.pdfHistory = null;
        this.pdfHistorySrcHD = null;
        this.progressBar.show();

        try {
            this.persistOnlyOfficeDocument(this.document)
                .then(() => {
                        const documentIds = this.selectedDocuments.map(
                            (document) => document.id,
                        );

                        console.log(documentIds);

                        this.medicalProvider
                            .generateRequestPdfListByGcp(documentIds)
                            .then((x) => {
                                let pdf = x.pdf as string;
                                var newBlob = new Blob([x], {
                                    type: "application/pdf",
                                });
                                const nav = window.navigator as any;

                                if (nav && nav.msSaveOrOpenBlob) {
                                    nav.msSaveOrOpenBlob(newBlob);
                                    this.isButtonDisabled = false;
                                    return;
                                }

                                const data =
                                    window.URL.createObjectURL(newBlob);

                                this.progressBar.hide();
                                const dialogRef = this.dialog.open(
                                    PrintGcpComponent,
                                    {
                                        height: "80%",
                                        width: "80%",
                                        data: { pdf },
                                        restoreFocus: false,
                                    },
                                );

                                dialogRef.afterClosed().subscribe(() => {
                                    this.pdfSrc = null;
                                });

                                this.isButtonDisabled = false;
                            })
                            .catch((err) => {
                                console.error("Erro ao gerar PDF", err);
                                this.isButtonDisabled = false;
                                this.progressBar.hide();
                            });
                })
                .catch((err) => {
                    console.error("Erro ao salvar", err);
                    this.snackBar.warnMessage("O documento não foi salvo. A impressão foi cancelada.");
                    this.isButtonDisabled = false;
                    this.progressBar.hide();
                });
        } catch (err) {
            console.error("Erro inesperado", err);
            this.isButtonDisabled = false;
            this.progressBar.hide();
        }
    }
}
